import { API } from "@infra/api";
import { loadAttachment } from "@infra/browser/download";
import { MissionsLoader } from "@infra/missions/MissionsLoader";
import { makeMissionsUseCases } from "@app/missions";
import type { IAttachmentDownloader } from "@ports/browser/IAttachmentDownloader";

const attachmentDownloader: IAttachmentDownloader = {
	load: (attachment, recordId, responseType) => loadAttachment(attachment, recordId, responseType),
};

const missionLoader = new MissionsLoader({ downloader: attachmentDownloader });

export const missionsUseCases = makeMissionsUseCases({
	missionLoader,
	missionsApi: {
		fudgeCores: (jobId, cores) => API.Missions.fudgeCores(jobId, cores),
		updateCores: (jobId, cores) => API.Missions.updateCores(jobId, cores),
		deleteCores: (jobId, coreIds) => API.Missions.deleteCores(jobId, coreIds),
		setAverageCoreLength: (jobId, coreIds) => API.Missions.setAverageCoreLength(jobId, coreIds),
	},
	jobIssuesApi: {
		fixExeMissionValidationJobs: (ids) => API.Data.Jobs.issues.fixExeMissionValidationJobs(ids),
	},
});
